<template>
  <v-snackbar v-model="isOpen" :timeout="-1" top>
    <template v-slot:default>
      <div class="align-center" :class="$vuetify.breakpoint.smAndDown ? 'd-block' : 'd-flex'">
        <div>
          {{ $t('update_available') }}
          {{
            $route.name === 'createPermit' || $route.name === 'editPermit'
              ? ` ${$t('update_available_permit_form_is_open')}`
              : ''
          }}
        </div>
        <div class="text-center" :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : ''">
          <v-btn color="accent" text @click="reloadPage">
            {{ $t('reload_page') }}
          </v-btn>
        </div>
      </div>
    </template>
  </v-snackbar>
</template>

<script>
import axios from 'axios';

export default {
  name: 'UpdateNotifier',

  data() {
    return {
      isOpen: false,
      currentVersion:
        document.querySelector("meta[name='app-version']")?.getAttribute('content') || '',
      fetchIntervalId: null,
    };
  },

  computed: {
    metadataUrl() {
      return `${import.meta.env.VITE_APP_PUBLIC_PATH}metadata.json`;
    },
  },

  async mounted() {
    console.log('Current version: ', this.currentVersion);
    await this.checkForUpdates();
    this.fetchIntervalId = setInterval(this.checkForUpdates, 60000);
  },

  beforeDestroy() {
    clearInterval(this.fetchIntervalId);
  },

  methods: {
    reloadPage() {
      const url = new URL(window.location.href);
      url.searchParams.delete('no-cache');
      url.searchParams.append('no-cache', new Date().getTime().toString());
      window.location.href = url.href;
    },

    async checkForUpdates() {
      const { data } = await axios.get(`${this.metadataUrl}?no-cache=${new Date().getTime()}`);
      if (data.version !== this.currentVersion) {
        console.log('New version available: ', data.version);
        this.isOpen = true;
      }
    },
  },
};
</script>

<style scoped></style>
